import { Routes } from '@angular/router';

import { CampaignManagementGuard } from '../mps/guards/domain/campaign-management.guard';
import { MyRequestsGuard } from '../mps/guards/domain/my-requests.guard';
import { RequestsManagementGuard } from '../mps/guards/domain/requests-management.guard';
import { RequestsMultipleManagementGuard } from '../mps/guards/domain/requests-multiple-management.guard';
import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { applicationRouteNames } from './application-route-names';
import { PaieHomeRedirectGuard } from './guards/paie-home-redirect.guard';
import { PayrollExportGuard } from './guards/payroll-export.guard';

export const applicationRoutes: Routes = [
  {
    path: applicationRouteNames.home,
    loadChildren: () => import('./mps-home/mps-home.routes').then((m) => m.mpsHomeRoutes),
    data: { title: 'general.navigation.home' },
    canActivate: [MpsLoggedInGuard, PaieHomeRedirectGuard],
    canLoad: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.campaignManagement,
    loadChildren: () =>
      import('./modules/campaign-management/campaign-management.routes').then((m) => m.campaignManagementRoutes),
    data: { title: 'general.navigation.campaign_management' },
    canActivate: [CampaignManagementGuard],
    canLoad: [CampaignManagementGuard],
  },
  {
    path: applicationRouteNames.requestsMultipleManagement,
    loadComponent: () =>
      import('./modules/requests-management/requests-multiple-management/requests-multiple-management.component').then(
        (m) => m.RequestsMultipleManagementComponent
      ),
    data: { title: 'general.navigation.requests_management' },
    canActivate: [RequestsMultipleManagementGuard],
    canLoad: [RequestsMultipleManagementGuard],
  },
  {
    path: applicationRouteNames.requestsManagement,
    loadChildren: () =>
      import('./modules/requests-management/requests-management.routes').then((m) => m.requestsManagementRoutes),
    data: { title: 'general.navigation.requests_management' },
    canActivate: [RequestsManagementGuard],
    canLoad: [RequestsManagementGuard],
  },
  {
    path: applicationRouteNames.myRequests,
    loadChildren: () => import('./modules/my-requests/my-requests.routes').then((m) => m.myRequestsRoutes),
    data: { title: 'general.navigation.my_requests' },
    canActivate: [MyRequestsGuard],
    canLoad: [MyRequestsGuard],
  },
  {
    path: applicationRouteNames.payrollExport,
    loadComponent: () =>
      import('./modules/payroll-export/payroll-export.component').then((m) => m.PayrollExportComponent),
    data: { title: 'general.navigation.payroll_export' },
    canActivate: [PayrollExportGuard],
    canLoad: [PayrollExportGuard],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration' },
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.branchLetterConfigs,
        loadComponent: () =>
          import('./administration/branch-letter-configs/branch-letter-configs.component').then(
            (m) => m.BranchLetterConfigsComponent
          ),
        data: { title: 'general.navigation.branch_letter_configs' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
];
